interface IsPaymentCardExpiredArgs {
  expMonth: string;
  expYear: string;
}

const isPaymentCardExpired = ({
  expMonth,
  expYear,
}: IsPaymentCardExpiredArgs): boolean => {
  const year = Number(expYear);
  const month = Number(expMonth) - 1;

  const expDate = new Date(year, month);
  const expDateInMs = expDate.getTime();
  const now = Date.now();

  return now - expDateInMs > 0;
};

export default isPaymentCardExpired;
